<template>
    <div class="row">
        <div class="col-md-2">
            <input type="number" class="limitPromoQty form-control" v-model="rule.settings.quantity" min="0" />
        </div>
        <div class="col-md-1">
            total
        </div>
    </div>
</template>

<script>
    export default {
        props: {
             rule: Object
        }
    }
</script>